import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { navigateToChangeInsightDetails } from '../links/index.jsx';
import styles from './ParticipationLabel.module.css';

const ParticipationLabel = (props) => {
  const {
    typeParticipating,
    initiative,
    initiativeParticipation,
    isActive,
    label,
    handleResetSearch,
  } = props;

  const initiativeParticipationId = initiativeParticipation?.id;
  const labelText = initiativeParticipation
    ? `${initiativeParticipation.label ? initiativeParticipation.label : initiativeParticipation.name} (${typeParticipating === 'stakeholder' ? initiativeParticipation.children.length : initiativeParticipation.leavesSurveyCount})`
    : label;

  const isLabelArchived = (label) => {
    return initiativeParticipation?.archived ? (
      <span className="text-muted">{label}</span>
    ) : (
      label
    );
  };

  const handleClick = (participantId) => {
    // if (handleResetSearch) {
    //   handleResetSearch(
    //     typeParticipating === 'stakeholder'
    //       ? 'stakeholderSearch'
    //       : 'groupSearch'
    //   );
    // }
    const specificPayload =
      typeParticipating === 'stakeholder'
        ? { organizationStakeholderIds: [] }
        : { employeeIds: [], groupIds: [] };

    navigateToChangeInsightDetails(
      {
        [typeParticipating]: participantId ? [participantId] : [],
        statuses: [],
        ...specificPayload,
      },
      initiative?.id,
      initiative?.type
    );
  };

  return (
    <a
      onClick={() => handleClick(initiativeParticipationId)}
      className={classNames('cursor-pointer', { 'text-active': isActive })}
    >
      <strong className={styles.strong}>{isLabelArchived(labelText)}</strong>
    </a>
  );
};

ParticipationLabel.propTypes = {
  initiative: PropTypes.object.isRequired,
  initiativeParticipation: PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string,
    leavesCount: PropTypes.number.isRequired,
    leavesCompletedCount: PropTypes.number,
    surveyLeavesAverageSentiment: PropTypes.string,
  }),
  isActive: PropTypes.bool,
  showCompletionDot: PropTypes.bool,
  showSentimentDot: PropTypes.bool,
  showOutlineBox: PropTypes.bool,
  label: PropTypes.string,
  status: PropTypes.string,
  sentiment: PropTypes.string,
};

ParticipationLabel.defaultProps = {
  isActive: false,
  showCompletionDot: false,
  showSentimentDot: false,
  showOutlineBox: false,
};

export default ParticipationLabel;
